export const CapitalizeWords = (value: string) => {
    let result = value.split(' ').map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
    return result;
}